






























import {Vue, Component, Prop} from 'vue-property-decorator';
import SingleFax from '@/components/Cartable/UnknownFaxAndEmails/SingleFax/SingleFax.vue';
import * as faxService from '@/store/Services/FaxService';
import * as letterService from '@/store/Services/letterServices';
import {ReceivedMessageFromFaxServiceDto} from '@/store/models/LetterOwner/RecievedMessageFromFaxServiceDto';

@Component({components:{SingleFax}})
export default class  UnknownFaxAndEmails extends Vue {
    faxes: ReceivedMessageFromFaxServiceDto[] = [];
    serverTime: any = {};
    loading = false;
    searchText = "";
    async created(){
        this.loading = true;
        this.serverTime = await letterService.getServerTime();
        this.faxes = await faxService.getAllFaxAndEmails();
        this.faxes.forEach(f=>f.isSelected = false);
        this.loading = false;
        
    }
    
    get filteredFaxes(){
        if(this.searchText !== "")
            return this.faxes.filter(f=> f.from.toLowerCase().includes(this.searchText.toLowerCase()));
        return this.faxes;
    }
    // onFaxSelected(faxData: ReceivedMessageFromFaxServiceDto){
    //     this.faxes.forEach(f=>f.isSelected = false);
    //     faxData.isSelected = true;

    // }

    onFaxSelected(faxData: ReceivedMessageFromFaxServiceDto){
        let index = 0;
        const tempFax: any = {};
        let selectedFax: any = {};
        if(this.faxes && this.faxes.length > 0){
            this.faxes.forEach((item,i)=>{
                item.isSelected = false;
                if(item.id === faxData.id){
                    index = i;
                    Object.assign(tempFax,item);
                }
            });

            tempFax.isSelected = true;
            this.$set(this.faxes,index,tempFax);
            selectedFax =  this.faxes.find(item=>item.id === faxData.id);
        }
       
        this.$emit("selected-fax-changed",selectedFax);
    }
    //dont remove this dummy method
    refresh(){
        //Do nothing...

    }
}

